import { useState, useEffect } from 'react';
import { ItemConnectionSort } from '../graphql/types';
import { PriceViewMode } from '../components/GeneralAdsPage/types';
import { CATEGORY_PRICE_VIEW_CONFIG } from '../utils/helpers/categoryPriceConfig';

export function useInitialPriceView(
  categoryId: string | undefined,
  sorting: ItemConnectionSort
) {
  const config = CATEGORY_PRICE_VIEW_CONFIG[categoryId!];

  const [priceView, setPriceView] = useState<PriceViewMode | null>(
    config ? config.detect(sorting, null) : null
  );

  useEffect(() => {
    if (config) {
      setPriceView(prev => config.detect(sorting, prev));
    } else {
      setPriceView(null);
    }
  }, [categoryId, sorting, config]);

  const priceViewOptions = config ? config.modes : [];

  return { priceView, setPriceView, priceViewOptions };
}
